import { TableColumn } from '@app/shared/components/data-table/data-table.component';
import { FormFieldConfig } from '@shared/components/search-form/search-form.component';

export interface O2oChangeHistorySearchParams {
  innerOrderNo?: string;
  outerOrderNo?: string;
  fieldName?: string;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  size?: number;
}

/** Sentinel for "all fields" — must be non-empty so p-floatlabel stays raised. */
export const O2O_CHANGE_HISTORY_FIELD_ALL = 'ALL';

export const O2O_CHANGE_HISTORY_FIELD_OPTIONS = [
  {
    label: 'o2o.change_history.search.field_delivery_retry',
    value: 'deliveryRetry',
  },
  {
    label: 'o2o.change_history.search.field_all',
    value: O2O_CHANGE_HISTORY_FIELD_ALL,
  },
];

export const O2O_CHANGE_HISTORY_SEARCH_CONFIG: FormFieldConfig[] = [
  {
    key: 'innerOrderNo',
    label: 'o2o.change_history.search.inner_order_no',
    type: 'text',
    placeholder: 'o2o.change_history.search.inner_order_no_placeholder',
  },
  {
    key: 'outerOrderNo',
    label: 'o2o.change_history.search.outer_order_no',
    type: 'text',
    placeholder: 'o2o.change_history.search.outer_order_no_placeholder',
  },
  {
    key: 'fieldName',
    label: 'o2o.change_history.search.field_name',
    type: 'select',
    placeholder: 'o2o.change_history.search.select_field',
    options: O2O_CHANGE_HISTORY_FIELD_OPTIONS,
  },
  {
    key: 'creationDate',
    label: 'o2o.change_history.search.creation_date',
    type: 'dateRange',
    range: { startKey: 'dateFrom', endKey: 'dateTo' },
  },
];

export const O2O_CHANGE_HISTORY_TABLE_COLUMNS: TableColumn[] = [
  {
    label: 'o2o.change_history.table.columns.inner_order_no',
    prop: 'innerOrderNo',
    width: 160,
    type: 'custom',
    template: 'orderLinkTemplate',
  },
  {
    label: 'o2o.change_history.table.columns.outer_order_no',
    prop: 'outerOrderNo',
    width: 140,
  },
  {
    label: 'o2o.change_history.table.columns.note',
    prop: 'note',
    width: 280,
    type: 'custom',
    template: 'noteTemplate',
  },
  {
    label: 'o2o.change_history.table.columns.before',
    prop: 'oldValue',
    width: 220,
    type: 'custom',
    template: 'valueTemplate',
  },
  {
    label: 'o2o.change_history.table.columns.after',
    prop: 'newValue',
    width: 220,
    type: 'custom',
    template: 'valueTemplate',
  },
  {
    label: 'o2o.change_history.table.columns.user',
    prop: 'fullName',
    width: 120,
    type: 'custom',
    template: 'userTemplate',
  },
  {
    label: 'o2o.change_history.table.columns.time',
    prop: 'creationDate',
    width: 170,
    type: 'custom',
    template: 'dateTemplate',
  },
];
